var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtrRevokedStatusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.837891 6.50349C0.837891 2.91387 3.74785 0.00390625 7.33747 0.00390625C10.9271 0.00390625 13.8371 2.91387 13.8371 6.50349C13.8371 10.0931 10.9271 13.0031 7.33747 13.0031C3.74785 13.0031 0.837891 10.0931 0.837891 6.50349ZM9.86419 5.5018C10.1049 5.16474 10.0269 4.69633 9.68982 4.45557C9.35276 4.21482 8.88434 4.29289 8.64359 4.62994L6.76252 7.26343L5.95116 6.45207C5.65827 6.15918 5.18339 6.15918 4.8905 6.45207C4.59761 6.74496 4.59761 7.21984 4.8905 7.51273L6.3279 8.95013C6.48379 9.10602 6.70037 9.18542 6.92009 9.16724C7.1398 9.14906 7.34039 9.03512 7.46853 8.85573L9.86419 5.5018Z",
    fill: "#60636B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtrRevokedStatusIcon);
export default __webpack_public_path__ + "static/media/etr-revoked-status-icon.4276cfd895aaf45e48f933413287b995.svg";
export { ForwardRef as ReactComponent };